import { SUEZ_CANAL_ID } from '@/lib/constants';
import { OptionModel } from '@/lib/models/option/types';

export const getDoesRouteTransitSuez = (options: OptionModel[]): boolean => {
  return options.reduce((bool, option) => {
    if (option.via?.find((v) => v.locationId === SUEZ_CANAL_ID)) {
      return true;
    }

    return bool;
  }, false);
};
